import React, { useContext, useEffect, useRef, useState , useCallback } from "react";
import { StyleSheet, View, Dimensions } from "react-native";
import { Modal, Text, TouchableOpacity, Platform } from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import { Feather } from "@expo/vector-icons";
import Spinner from "../../../components/shared/Spinner";
import DeviceOrientationContext from "../../../components/context/DeviceOrientationContext";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useToast } from "react-native-toast-notifications";
import { LabelBannerWithSearchBar } from "../../../components/custom/Banners/LabelBannerWithSearchBar";
import {
  approveCancelledOrder,
  getAllCancelledOrders,
  getMergedTrackerOrders,
} from "../../../redux/dispatcher/chinaTrackerDispatcher";
import {
  translateFields,
  translateHeaders,
  useTranslation,
} from "../../../utils/useTranslation";
import { chinaTrackerTranslationMap } from "../../../utils/translations";
import {
  resetCancelledSearch,
  searchCancelledTrackerOrders,
} from "../../../redux/reducers/chinaTrackerReducer";
import { ChinaTrackerDataTableWithPagination2 } from "../../../components/custom/DataTable/tracker/ChinaTrackerDataTableWithPagination2";
import { MenuProvider } from "react-native-popup-menu";
import { useNavigation } from "@react-navigation/native";
import { DataTable } from "react-native-paper";
import AsyncStorage from "@react-native-async-storage/async-storage";
import TrackerHistoryModal from "./TrackerHistoryModal";
import ChinaShipmentsListModal from "./ChinaShipmentsListModal";
import ChinaTrackerDetailsReportModal from "./ChinaTrackerDetailsReportModal";
import ChinaTrackerTransferOrders from "./ChinaTrackerTransferOrders";

// Header definitions based on the table in the image
export const orderTrackingHeaders = {
  MSRef: {
    name: "MS No.",
    width: 0.3,
  },
  OrderNumber1: {
    name: "Order Number",
    width: 0.3,
  },
  allocateProductionLine: {
    name: "Production Line",
    width: 0.25,
  },
  ItemCode: {
    name: "Item Code",
    width: 0.3,
  },
  ItemName: {
    name: "Item Name",
    width: 0.65,
  },
  BPName: {
    name: "Customer",
    width: 0.65,
  },
  StateDelivery: {
    name: "State",
    width: 0.2,
  },
  OrderDate: {
    name: "PO Order Date",
    width: 0.3,
  },
  PriorityOrder: {
    name: "Priority Order",
    width: 0.25,
  },
  ArtworkNo: {
    name: "Artwork No",
    width: 0.2,
  },
  RequestDate: {
    name: "Due Date",
    width: 0.25,
  },
  TotalOrdered: {
    name: "Order Qty (Uom)",
    width: 0.3,
    textAlign: "center",
  },
  QtyToShip: {
    name: "Qty to Ship",
    width: 0.25,
  },
  FulfillmentPercent: {
    name: "Fulfilments %",
    width: 0.3,
  },
  Key: {
    name: "Key",
    width: 0.2,
    textAlign: "left",
    display: "hidden",
  },
  OrderStatus: {
    name: "Order Status",
    width: 0.2,
    textAlign: "left",
  },
  archivedActions: {
    name: "",
    width: 0.2,
    textAlign: "center",
    justifyContent: "center",
  },
};

const ChinaTrackerCancelledOrders: React.FC = ({
  visible,
  onClose,
  order,
}: any) => {
  const listRef = useRef<ScrollView>(null);
  const [screenWidth, setScreenWidth] = useState(
    Dimensions.get("window").width,
  );
  const [screenHeight, setScreenHeight] = useState(
    Dimensions.get("window").height,
  );
  const [tableHeaders, setTableHeaders] =
    useState<Partial<typeof orderTrackingHeaders>>(orderTrackingHeaders);

  const { cancelledOrders, loading, loadingCancel } = useSelector(
    (state: any) => state.chinaTracker,
  );
  const { t } = useTranslation();

  const [isSearched, setIsSearched] = useState<boolean>(false);
  const dispatch = useDispatch<any>();
  const [actionRows, setActionRows] = useState<any>([]);

  const [isRefresh, setRefresh] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);

  const [columnSettingsOpen, setColumnSettingsOpen] = useState(false);
  const [settingsBtnPos, setSettingsBtnPos] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  });
  const settingsBtnRef = useRef<any>(null);
  const [hiddenColumns, setHiddenColumns] = useState<Record<string, boolean>>(
    {},
  );

  useEffect(() => {
    AsyncStorage.getItem("chinatracker_archived_hidden_columns").then(
      (data) => {
        if (data) setHiddenColumns(JSON.parse(data));
      },
    );
  }, []);

  const toast = useToast();
  const { isLargeDevice, isMediumDevice, isSmallDevice } = useContext(
    DeviceOrientationContext,
  );
  const [, setContentOffSet] = useState<number>(0);

  const [modalOpen, setModalOpen] = useState<boolean>();
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [selectedEnquiryType, setSelectedEnquiryType] = useState<any>(null);

  console.log(selectedItem, "selected item");
  const [orders, setOrders] = useState<any[]>([]);

  const fromPage = (
    page: number,
    itemPerPage: number,
    rows: any[] | undefined,
  ) => {
    return page * itemPerPage + itemPerPage > (rows || []).length
      ? (rows || []).length
      : page * itemPerPage + itemPerPage;
  };

  const [statusFilter, setStatusFilter] = useState<string[]>(["all"]);

  const toggleStatusFilter = (filter: string) => {
    setPage(0);
    setStatusFilter((prev) => {
      if (filter === "all") return ["all"];
      
      const newFilters = prev.includes(filter)
        ? prev.filter((f) => f !== filter)
        : [...prev.filter((f) => f !== "all"), filter];
        
      return newFilters.length === 0 ? ["all"] : newFilters;
    });
  };
  const [sortDirection, setSortDirection] = useState<"recent" | "oldest">("recent");

  const applyStatusFilter = (data: any[]) => {
    if (statusFilter.includes("all")) return data;

    return data.filter((o) => {
      return statusFilter.includes(o.OrderStatus);
    });
  };

  const navigate = useNavigation();

  const navigateToOrder = (order: any, action: string) => {
    if (action === "accept") {
      const orders: any = [];
      for (const orderKey of order) {
        orders.push({
          key: orderKey.Key,
          orderNumber: orderKey.OrderNumber1,
          MSRef: orderKey.MSRef,
          itemName: orderKey.ItemName,
          itemCode: orderKey.ItemCode,
          orderDate: orderKey.OrderDate,
          requestDate: orderKey.RequestDate.trim(),
          state: orderKey.StateDelivery,
        });
      }
      const payload: any = {
        orders: orders,
      };
      dispatch(approveCancelledOrder(payload))
        .unwrap()
        .then(() => {
          toast.show("Incoming order approved successfully", {
            type: "success",
          });
          setActionRows([]);
          dispatch(getAllCancelledOrders()).unwrap();
        })
        .catch((error: any) => {
          toast.show(
            error || "Error occurred during approval of incoming order",
            {
              type: "danger",
            },
          );
        });
    } else {
      // onClose();
      if (action === "transfer") {
        const incomingRef = order?.incomingRef?._id;
        if (!incomingRef || incomingRef === "") {
          // toast.show("Incoming order reference not found for this order", {
          //   type: "danger",
          // });
          // return;
        }
      }
      setModalOpen(true);
      setSelectedItem(order);
      setSelectedEnquiryType(action);
    }
  };
  // Update dimensions when screen size changes
  useEffect(() => {
    const updateDimensions = () => {
      const { width, height } = Dimensions.get("window");
      setScreenWidth(width);
      setScreenHeight(height);
    };

    const dimensionsListener = Dimensions.addEventListener(
      "change",
      updateDimensions,
    );

    return () => {
      dimensionsListener.remove();
    };
  }, []);

  const handleScroll = (event: any) => {
    setContentOffSet(Math.floor(event.nativeEvent?.contentOffset?.y) ?? 0);
  };

  // Calculate modal width based on screen size
  const getModalWidth = () => {
    if (isSmallDevice) return "100%";
    if (isMediumDevice) return "94%";
    return "92%";
  };

  // Calculate inner container width based on screen size
  const getInnerContainerWidth = () => {
    if (isSmallDevice) return "100%";
    return "100%";
  };

  // Hook form setup
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleSearch = (searchedText: string) => {
    setPage(0);
    if (searchedText) {
      dispatch(searchCancelledTrackerOrders(searchedText));
    } else {
      dispatch(resetCancelledSearch());
    }
  };

  useEffect(() => {
    let isMounted: boolean = true;
    if (isRefresh) {
      dispatch(getMergedTrackerOrders({ refresh: true, showLoading: false }));
      setRefresh(false);
    }

    return () => {
      isMounted = false;
    };
  }, [isRefresh, isLargeDevice, isMediumDevice, isSmallDevice, screenWidth]);

  const getOrderedKeys = (baseHeaders: Record<string, Record<string, string | number | boolean>>) => {
    const allKeys = Object.keys(baseHeaders);
    if (columnOrder.length === 0) return allKeys;
    const ordered: string[] = [];
    columnOrder.forEach((k) => { if (allKeys.includes(k)) ordered.push(k); });
    allKeys.forEach((k) => { if (!ordered.includes(k)) ordered.push(k); });
    return ordered;
  };

  const getFilteredHeaders = () => {
    let headers = translateHeaders(
      orderTrackingHeaders,
      t,
      chinaTrackerTranslationMap,
    );
    const { Status, ...filteredObj } = headers;

    // Convert to array to calculate widths
    let entries = Object.entries(filteredObj);
    const visibleEntries = entries.filter(([key, _]) => !hiddenColumns[key]);

    // Scale widths sequentially
    const totalOriginalWidth = visibleEntries.reduce(
      (sum, [_, col]) => sum + ((col as any).width || 0),
      0,
    );
    const minDesiredWidth = 1.0;
    const scaleFactor =
      totalOriginalWidth < minDesiredWidth
        ? minDesiredWidth / totalOriginalWidth
        : 1;

    const newHeaders: any = {};
    visibleEntries.forEach(([key, col]: [string, any]) => {
      newHeaders[key] = {
        ...col,
        width: col.width * scaleFactor,
      };
    });

    return newHeaders;
  };

  useEffect(() => {
    setRefresh(false);

    let filtered = applyStatusFilter(cancelledOrders);

    // Sort by OrderDate (DD/MM/YYYY format)
    filtered = [...filtered].sort((a, b) => {
      const parseDate = (dateStr: string) => {
        if (!dateStr) return new Date(0);
        const [day, month, year] = dateStr.trim().split("/").map(Number);
        return new Date(year, month - 1, day);
      };
      const dateA = parseDate(a.OrderDate);
      const dateB = parseDate(b.OrderDate);
      return sortDirection === "recent"
        ? dateB.getTime() - dateA.getTime()
        : dateA.getTime() - dateB.getTime();
    });

    setOrders(filtered);

    setTableHeaders(getFilteredHeaders());
  }, [cancelledOrders, statusFilter, sortDirection, hiddenColumns]);

  return (
    <>
      {modalOpen && selectedEnquiryType === "history" && (
        <TrackerHistoryModal
          onClose={() => setModalOpen(false)}
          visible={modalOpen}
          order={selectedItem}
        />
      )}

      {modalOpen && selectedEnquiryType === "shipments" && (
        <ChinaShipmentsListModal
          onClose={() => setModalOpen(false)}
          visible={modalOpen}
          order={selectedItem}
        />
      )}

      {modalOpen && selectedEnquiryType === "view" && (
        <ChinaTrackerDetailsReportModal
          onClose={() => setModalOpen(false)}
          visible={modalOpen}
          order={selectedItem}
        />
      )}

      {modalOpen && selectedEnquiryType === "transfer" && (
        <ChinaTrackerTransferOrders
          onClose={() => setModalOpen(false)}
          visible={modalOpen}
          order={selectedItem}
        />
      )}

      <Modal visible={visible} transparent animationType="slide">
        <MenuProvider>
          <View style={styles.overlay}>
            {isLargeDevice ? (
              <View style={[styles.modalContainer, { width: getModalWidth() }]}>
                <View
                  style={[
                    styles.modalContainerSecond,
                    { width: getInnerContainerWidth(), height: "95%" },
                    isSmallDevice && styles.modalContainerMobile,
                  ]}
                >
                  <View
                    style={[
                      styles.titleContainer,
                      isSmallDevice && styles.titleContainerMobile,
                    ]}
                  >
                    <Text
                      style={[
                        styles.titleText,
                        isSmallDevice && styles.titleTextSmall,
                      ]}
                    >
                      {t("archievedOrders")}
                    </Text>
                    {!isSmallDevice && (
                      <View style={[styles.searchContainer]}>
                        <LabelBannerWithSearchBar
                          titleName={``}
                          handleSearch={handleSearch}
                          setRefresh={setRefresh}
                          dataToExport={orders}
                          fileName="ItemTrackerScreen"
                          sheetName="Item Tracker Report Screen"
                          extraControls={
                            <TouchableOpacity
                              ref={settingsBtnRef}
                              style={{
                                width: 40,
                                height: 40,
                                borderRadius: 10,
                                backgroundColor: "#F3F4F6",
                                justifyContent: "center",
                                alignItems: "center",
                                borderWidth: 1,
                                borderColor: columnSettingsOpen
                                  ? "#818CF8"
                                  : "#E2E8F0",
                              }}
                              onPress={() => {
                                if (settingsBtnRef.current) {
                                  settingsBtnRef.current.measureInWindow(
                                    (
                                      x: number,
                                      y: number,
                                      width: number,
                                      height: number,
                                    ) => {
                                      setSettingsBtnPos({
                                        x: x || 0,
                                        y: y || 0,
                                        width: width || 0,
                                        height: height || 0,
                                      });
                                      setColumnSettingsOpen(
                                        !columnSettingsOpen,
                                      );
                                    },
                                  );
                                } else {
                                  setColumnSettingsOpen(!columnSettingsOpen);
                                }
                              }}
                            >
                              <Feather
                                name="settings"
                                size={20}
                                color="#4B5563"
                              />
                            </TouchableOpacity>
                          }
                        />
                      </View>
                    )}
                  </View>

                  {isSmallDevice && (
                    <View
                      style={[
                        styles.searchContainerMobile,
                        { marginBottom: 10 },
                      ]}
                    >
                      <LabelBannerWithSearchBar
                        titleName={``}
                        handleSearch={handleSearch}
                        setRefresh={setRefresh}
                        dataToExport={orders}
                        fileName="ItemTrackerScreen"
                        sheetName="Item Tracker Report Screen"
                        extraControls={
                          <TouchableOpacity
                            ref={settingsBtnRef}
                            style={{
                              width: 40,
                              height: 40,
                              borderRadius: 10,
                              backgroundColor: "#F3F4F6",
                              justifyContent: "center",
                              alignItems: "center",
                              borderWidth: 1,
                              borderColor: columnSettingsOpen
                                ? "#818CF8"
                                : "#E2E8F0",
                            }}
                            onPress={() => {
                              if (settingsBtnRef.current) {
                                settingsBtnRef.current.measureInWindow(
                                  (
                                    x: number,
                                    y: number,
                                    width: number,
                                    height: number,
                                  ) => {
                                    setSettingsBtnPos({
                                      x: x || 0,
                                      y: y || 0,
                                      width: width || 0,
                                      height: height || 0,
                                    });
                                    setColumnSettingsOpen(!columnSettingsOpen);
                                  },
                                );
                              } else {
                                setColumnSettingsOpen(!columnSettingsOpen);
                              }
                            }}
                          >
                            <Feather
                              name="settings"
                              size={20}
                              color="#4B5563"
                            />
                          </TouchableOpacity>
                        }
                      />
                    </View>
                  )}

                  <View
                    style={[
                      { marginLeft: 15, marginTop: 10, marginBottom: 10, flexDirection: "row", alignItems: "center", justifyContent: "space-between" },
                    ]}
                  >
                    <ScrollView horizontal showsHorizontalScrollIndicator={false}>
                      <TouchableOpacity onPress={() => toggleStatusFilter("all")}>
                        <Text
                          style={
                            statusFilter.includes("all")
                              ? styles.selectedFilter
                              : styles.filterLabel
                          }
                        >
                          {t("all")}
                        </Text>
                      </TouchableOpacity>

                      <TouchableOpacity
                        onPress={() => toggleStatusFilter("Cancelled")}
                      >
                        <Text
                          style={
                            statusFilter.includes("Cancelled")
                              ? styles.selectedFilter
                              : styles.filterLabel
                          }
                        >
                          {t("cancelled")}
                        </Text>
                      </TouchableOpacity>

                      <TouchableOpacity
                        onPress={() => toggleStatusFilter("Closed")}
                      >
                        <Text
                          style={
                            statusFilter.includes("Closed")
                              ? styles.selectedFilter
                              : styles.filterLabel
                          }
                        >
                          {t("closed")}
                        </Text>
                      </TouchableOpacity>

                      <TouchableOpacity
                        onPress={() => toggleStatusFilter("Completed")}
                      >
                        <Text
                          style={
                            statusFilter.includes("Completed")
                              ? styles.selectedFilter
                              : styles.filterLabel
                          }
                        >
                          {t("completed")}
                        </Text>
                      </TouchableOpacity>

                      <View style={{ width: 16 }} />
                      <View style={{ width: 1, height: 24, backgroundColor: "#E2E8F0", marginHorizontal: 4 }} />
                      <View style={{ width: 8 }} />

                      <TouchableOpacity onPress={() => setSortDirection("recent")}>
                        <Text
                          style={
                            sortDirection === "recent"
                              ? styles.selectedFilter
                              : styles.filterLabel
                          }
                        >
                          ↓ Recent
                        </Text>
                      </TouchableOpacity>

                      <TouchableOpacity onPress={() => setSortDirection("oldest")}>
                        <Text
                          style={
                            sortDirection === "oldest"
                              ? styles.selectedFilter
                              : styles.filterLabel
                          }
                        >
                          ↑ Oldest
                        </Text>
                      </TouchableOpacity>
                    </ScrollView>
                  </View>

                  <ScrollView onScroll={handleScroll} ref={listRef}>
                    <ScrollView
                      horizontal
                      showsHorizontalScrollIndicator
                      contentContainerStyle={{
                        minWidth: Math.max(screenWidth, 1200),
                      }}
                    >
                      <View
                        style={[
                          styles.containerContent,
                          { minWidth: Math.max(screenWidth, 1200) },
                        ]}
                      >
                        {loading || loadingCancel ? (
                          <Spinner
                            size="small"
                            color="#74BBFF"
                            styles={{ flexDirection: "row", margin: "20%" }}
                          />
                        ) : (
                          <ChinaTrackerDataTableWithPagination2
                            headers={tableHeaders}
                            rows={orders}
                            itemsPerPage={10}
                            isDataLoading={isSearched}
                            isDisplayTimeWithDate={true}
                            useModal={true}
                            isDetail={false}
                            isEdit={false}
                            isDelete={false}
                            actionRows={actionRows}
                            setActionRows={setActionRows}
                            itemTracker
                            setModalVisible={() => {}}
                            handleRowClick={() => {}}
                            setSelected={() => {}}
                            handleDeleteRow={() => {}}
                            t={t}
                            page={page}
                            setPage={setPage}
                            operationActions={navigateToOrder}
                            selectable={true}
                            hidePagination={true}
                          />
                        )}
                      </View>
                    </ScrollView>
                  </ScrollView>
                  <View
                    style={{
                      borderTopWidth: 1,
                      borderTopColor: "#E2E8F0",
                      backgroundColor: "#fff",
                    }}
                  >
                    <DataTable.Pagination
                      page={page}
                      numberOfPages={Math.ceil(orders.length / 10)}
                      onPageChange={(p) => setPage(p)}
                      label={`${fromPage(page, 10, orders)} of ${orders.length}`}
                      showFastPaginationControls
                      numberOfItemsPerPage={10}
                      selectPageDropdownLabel={"Rows per page"}
                    />
                  </View>
                  <View
                    style={[styles.footer, isSmallDevice && styles.footerSmall]}
                  >
                    <TouchableOpacity
                      onPress={onClose}
                      style={[
                        styles.closeButton,
                        isSmallDevice && styles.buttonSmall,
                      ]}
                    >
                      <Text style={isSmallDevice && styles.buttonTextSmall}>
                        {t("close")}
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
              </View>
            ) : (
              <View
                style={[
                  styles.modalContainerSecond,
                  { width: "100%", height: "95%" },
                  isSmallDevice && styles.modalContainerMobile,
                ]}
              >
                <View
                  style={[
                    styles.titleContainer,
                    isSmallDevice && styles.titleContainerMobile,
                  ]}
                >
                  <Text
                    style={[
                      styles.titleText,
                      isSmallDevice && styles.titleTextSmall,
                    ]}
                  >
                    {t("archievedOrders")}
                  </Text>
                  {!isSmallDevice && (
                    <View style={[styles.searchContainer]}>
                      <LabelBannerWithSearchBar
                        titleName={``}
                        handleSearch={handleSearch}
                        setRefresh={setRefresh}
                        dataToExport={orders}
                        fileName="ItemTrackerScreen"
                        sheetName="Item Tracker Report Screen"
                      />
                    </View>
                  )}
                </View>

                {isSmallDevice && (
                  <View
                    style={[styles.searchContainerMobile, { marginBottom: 10 }]}
                  >
                    <LabelBannerWithSearchBar
                      titleName={``}
                      handleSearch={handleSearch}
                      setRefresh={setRefresh}
                      dataToExport={orders}
                      fileName="ItemTrackerScreen"
                      sheetName="Item Tracker Report Screen"

                    />
                  </View>
                )}



                <ScrollView
                  onScroll={handleScroll}
                  ref={listRef}
                  style={isSmallDevice && styles.scrollBodySectionMobile}
                >
                  <ScrollView
                    horizontal
                    showsHorizontalScrollIndicator
                    contentContainerStyle={{
                      minWidth: isSmallDevice ? 900 : Math.max(screenWidth, 1200),
                    }}
                  >
                    <View
                      style={[
                        styles.containerContent,
                        { minWidth: isSmallDevice ? 900 : Math.max(screenWidth, 1200) },
                      ]}
                    >
                      {loading || loadingCancel ? (
                        <Spinner
                          size="small"
                          color="#74BBFF"
                          styles={{ flexDirection: "row", margin: "20%" }}
                        />
                      ) : (
                        <ChinaTrackerDataTableWithPagination2
                          headers={tableHeaders}
                          rows={orders}
                          itemsPerPage={10}
                          isDataLoading={isSearched}
                          isDisplayTimeWithDate={true}
                          useModal={true}
                          isDetail={false}
                          isEdit={false}
                          isDelete={false}
                          actionRows={actionRows}
                          setActionRows={setActionRows}
                          itemTracker
                          setModalVisible={() => {}}
                          handleRowClick={() => {}}
                          setSelected={() => {}}
                          handleDeleteRow={() => {}}
                          t={t}
                          page={page}
                          setPage={setPage}
                          operationActions={navigateToOrder}
                          selectable={true}
                          hidePagination={true}
                        />
                      )}
                    </View>
                  </ScrollView>
                </ScrollView>
                <View
                  style={{
                    borderTopWidth: 1,
                    borderTopColor: "#E2E8F0",
                    backgroundColor: "#fff",
                  }}
                >
                  <DataTable.Pagination
                    page={page}
                    numberOfPages={Math.ceil(orders.length / 10)}
                    onPageChange={(p) => setPage(p)}
                    label={`${fromPage(page, 10, orders)} of ${orders.length}`}
                    showFastPaginationControls
                    numberOfItemsPerPage={10}
                    selectPageDropdownLabel={"Rows per page"}
                  />
                </View>
                <View
                  style={[styles.footer, isSmallDevice && styles.footerSmall]}
                >
                  <TouchableOpacity
                    onPress={onClose}
                    style={[
                      styles.closeButton,
                      isSmallDevice && styles.buttonSmall,
                    ]}
                  >
                    <Text style={isSmallDevice && styles.buttonTextSmall}>
                      Close
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            )}
          </View>
        </MenuProvider>
      </Modal>

      {columnSettingsOpen && (
        <Modal transparent visible={true} animationType="none">
          <TouchableOpacity
            style={{ flex: 1 }}
            activeOpacity={1}
            onPress={() => setColumnSettingsOpen(false)}
          >
            <TouchableOpacity
              activeOpacity={1}
              style={{
                position: "absolute",
                top:
                  Platform.OS === "web"
                    ? settingsBtnPos.y + settingsBtnPos.height + 5
                    : "18%",
                left: Platform.OS === "web" ? settingsBtnPos.x - 200 : "10%",
                width: Platform.OS === "web" ? 240 : "80%",
                backgroundColor: "#fff",
                borderRadius: 12,
                borderWidth: 1,
                borderColor: "#E2E8F0",
                paddingVertical: 10,
                minWidth: 220,
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 8 },
                shadowOpacity: 0.15,
                shadowRadius: 20,
                elevation: 10,
                zIndex: 9999,
                maxHeight: Platform.OS === "web" ? "auto" : "70%",
              }}
            >
              <Text
                style={{
                  fontSize: 12,
                  fontWeight: "700",
                  color: "#6B7280",
                  paddingHorizontal: 16,
                  paddingBottom: 8,
                  textTransform: "uppercase",
                  letterSpacing: 0.5,
                }}
              >
                {t("showHideColumns")}
              </Text>
              <View
                style={{
                  height: 1,
                  backgroundColor: "#F1F5F9",
                  marginBottom: 4,
                }}
              />

              <TouchableOpacity
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  paddingVertical: 8,
                  paddingHorizontal: 16,
                }}
                onPress={() => {
                  const allVisible = Object.keys(hiddenColumns).length === 0;
                  if (allVisible) {
                    const allHeaders = translateHeaders(
                      orderTrackingHeaders,
                      t,
                      chinaTrackerTranslationMap,
                    );
                    const { Status, ...filtered } = allHeaders;
                    const allHidden: Record<string, boolean> = {};
                    Object.keys(filtered).forEach((k) => (allHidden[k] = true));
                    setHiddenColumns(allHidden);
                    AsyncStorage.setItem(
                      "chinatracker_archived_hidden_columns",
                      JSON.stringify(allHidden),
                    );
                  } else {
                    setHiddenColumns({});
                    AsyncStorage.removeItem(
                      "chinatracker_archived_hidden_columns",
                    );
                  }
                }}
              >
                <View
                  style={{
                    width: 20,
                    height: 20,
                    borderRadius: 4,
                    borderWidth: 1.5,
                    borderColor:
                      Object.keys(hiddenColumns).length === 0
                        ? "#56B7FD"
                        : "#D1D5DB",
                    backgroundColor:
                      Object.keys(hiddenColumns).length === 0
                        ? "#56B7FD"
                        : "#fff",
                    marginRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {Object.keys(hiddenColumns).length === 0 && (
                    <Feather name="check" size={13} color="#fff" />
                  )}
                </View>
                <Text
                  style={{ fontSize: 14, color: "#111827", fontWeight: "700" }}
                >
                  Select All
                </Text>
              </TouchableOpacity>
              <View
                style={{
                  height: 1,
                  backgroundColor: "#F1F5F9",
                  marginBottom: 2,
                }}
              />

              <ScrollView
                style={{ maxHeight: 300 }}
                showsVerticalScrollIndicator={true}
              >
                {Object.entries(
                  translateHeaders(
                    orderTrackingHeaders,
                    t,
                    chinaTrackerTranslationMap,
                  ),
                )
                  .filter(
                    ([k, col]: [string, any]) =>
                      k !== "Status" &&
                      k !== "" &&
                      col.display !== "none" &&
                      col.display !== "hidden",
                  )
                  .map(([key, col]: [string, any]) => (
                    <TouchableOpacity
                      key={key}
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        paddingVertical: 8,
                        paddingHorizontal: 16,
                      }}
                      onPress={() => {
                        const newHidden = { ...hiddenColumns };
                        if (newHidden[key]) {
                          delete newHidden[key];
                        } else {
                          newHidden[key] = true;
                        }
                        setHiddenColumns(newHidden);
                        AsyncStorage.setItem(
                          "chinatracker_archived_hidden_columns",
                          JSON.stringify(newHidden),
                        );
                      }}
                    >
                      <View
                        style={{
                          width: 20,
                          height: 20,
                          borderRadius: 4,
                          borderWidth: 1.5,
                          borderColor: !hiddenColumns[key]
                            ? "#56B7FD"
                            : "#D1D5DB",
                          backgroundColor: !hiddenColumns[key]
                            ? "#56B7FD"
                            : "#fff",
                          marginRight: 10,
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {!hiddenColumns[key] && (
                          <Feather name="check" size={13} color="#fff" />
                        )}
                      </View>
                      <Text style={{ fontSize: 14, color: "#374151", flex: 1 }}>
                        {key === "archivedActions" ? "Action" : col.name || key}
                      </Text>
                    </TouchableOpacity>
                  ))}
              </ScrollView>
            </TouchableOpacity>
          </TouchableOpacity>
        </Modal>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.15)",
    paddingVertical: 16,
    paddingHorizontal: 8,
  },
  modalContainer: {
    backgroundColor: "#fff",
    padding: 20,
    elevation: 12,
    borderRadius: 12,
    width: "100%",
    maxHeight: "95%",
  },
  modalContainerSecond: {
    backgroundColor: "#fff",
    elevation: 12,
    borderRadius: 12,
    padding: 16,
    width: "100%",
    height: "95%",
  },
  titleContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
    backgroundColor: "#FFFFFF",
    paddingVertical: 12,
    marginBottom: 12,
  },
  titleText: {
    fontSize: 18,
    fontWeight: "700",
  },
  titleTextSmall: {
    fontSize: 14,
  },
  searchContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  searchInput: {
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 4,
    padding: 8,
    width: 200,
  },
  searchButton: {
    backgroundColor: "#f0f0f0",
    padding: 8,
    borderRadius: 4,
    marginLeft: 5,
  },
  tabsContainer: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
    marginBottom: 8,
  },
  tab: {
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderBottomWidth: 2,
    borderBottomColor: "transparent",
  },
  activeTab: {
    borderBottomColor: "#3498db",
  },
  tabText: {
    color: "#999",
  },
  activeTabText: {
    color: "#3498db",
    fontWeight: "600",
  },
  actionButtonsContainer: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginBottom: 12,
    gap: 10,
  },
  actionButton: {
    backgroundColor: "#56B7FD",
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 8,
    marginLeft: 10,
    minWidth: 80,
    alignItems: "center",
    justifyContent: "center",
  },
  disabledActionButton: {
    backgroundColor: "#E5E7EB",
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 8,
    marginLeft: 10,
    minWidth: 80,
    alignItems: "center",
    justifyContent: "center",
  },
  actionButtonText: {
    fontSize: 13,
    color: "#fff",
    fontWeight: "700",
  },
  formSection: {
    marginTop: 20,
    paddingHorizontal: 10,
  },
  footer: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    marginTop: 20,
    padding: 25,
  },
  footerSmall: {
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  closeButton: {
    padding: 10,
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 5,
    width: 120,
    alignItems: "center",
  },
  buttonSmall: {
    padding: 8,
    paddingHorizontal: 12,
  },
  buttonTextSmall: {
    fontSize: 12,
  },
  containerContent: {
    flexDirection: "column",
    alignSelf: "flex-start",
    width: "100%",
    paddingHorizontal: 0,
    paddingBottom: 0,
  },

  tableScrollWrapper: {
    flex: 1,
    maxHeight: 520,
    width: "100%",
  },

  filterLabel: {
    fontSize: 12,
    fontWeight: "500",
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 20,
    marginHorizontal: 4,
    backgroundColor: "#F1F5F9",
    color: "#4B5563",
    overflow: "hidden",
  },

  selectedFilter: {
    fontSize: 12,
    fontWeight: "600",
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 20,
    marginHorizontal: 4,
    backgroundColor: "#56B7FD",
    color: "#fff",
    overflow: "hidden",
  },
  modalContainerMobile: {
    padding: 10,
    borderRadius: 10,
  },
  titleContainerMobile: {
    flexDirection: "column",
    alignItems: "stretch",
    paddingVertical: 8,
    marginBottom: 4,
    gap: 6,
  },
  searchContainerMobile: {
    width: "100%",
  },
  scrollBodySectionMobile: {
    paddingTop: 4,
  },
});

export default ChinaTrackerCancelledOrders;
